module.exports = __webpack_public_path__ + "static/media/IMG-6.539d7620.jpg";